import Logo from "../ui/Logo";
import React from "react";
import styled from "styled-components";

const LogoContainer: React.FC = () => {
    const logos = [{ path: "con-i-bambini.png" }, { path: "goal-transparent.png" }, { path: "cpia-lecce-transparent.png" }];
    return (
        <Container>
            {logos.map((logo: { path: string; padding?: number }) => (
                <Logo key={logo.path} logo={logo.path} padding={logo.padding} />
            ))}
        </Container>
    );
};

export default LogoContainer;

const Container = styled.div`
    width: 100%;
    min-height: 30vh;
    text-align: center;
    padding: 2rem 0;
    background-color: ${props => props.theme.colors.white(1)};
    box-shadow: 0px 3px 1px -2px ${props => props.theme.colors.black(0.2)}, 0px 2px 2px 0px ${props => props.theme.colors.black(0.14)},
        0px 1px 5px 0px ${props => props.theme.colors.black(0.12)};
`;
